import React, { useState, useEffect } from "react";
import moment from "moment"
import {
    Card,
    CardBody,
    Col,
    Container,
    Form,
    FormGroup,
    Input,
    Label,
    Row,
    TabContent,
    TabPane,
    Progress,
    NavLink,
    NavItem,
    Button,
    CardTitle,
    FormFeedback,
    FormText,
} from "reactstrap";
import classnames from "classnames";
import { Link, Navigate, useLocation } from "react-router-dom";
import Async from "react-select/async"
import "react-datetime/css/react-datetime.css";
import Datetime from "react-datetime";
import { SUPER_ADMIN } from "../../../store/users/role.constants";
import { clearUpdateMasterDeviceError, updateMasterDevice } from "../../../store/deviceDetails/actions";
import { getUsersForAsyncSelect } from "../../../store/actions";
import { connect } from "react-redux";
import Message from "../../../CommonData/Data/Message";
import { updateForm } from "../../../store/form/actions";
import VWLoading from "../../../components/vwLoading/vwLoading";

const FormWizard = (props) => {

    const location = useLocation();
    const queryString = location.pathname;
    const urlParams = queryString && queryString.split("/");
    const reqParams = (urlParams && urlParams.length) > 0 ? urlParams[2] : null;

    const [activeTabwiz, setoggleTabwiz] = useState(1);
    const [passedStepswiz, setpassedStepswiz] = useState([1]);
    const [masterDevice, setMasterDevice] = useState("");
    const [selected_user, setSelectedUser] = useState("");
    const [new_user_organisation, setNewUserOrganisation] = useState("");
    const { currentProfile, masterDeviceDetails, errorMessage, form, isSuccess, isPending } = props;
    const currentRole = currentProfile.roles && currentProfile.roles.length > 0 && currentProfile.roles[0]

    useEffect(() => {
        const isSuperAdmin = currentProfile.roles && currentProfile.roles.length > 0 &&
            currentProfile.roles[0].roleKey === SUPER_ADMIN;

        if (masterDeviceDetails) {
            const selected_user = {
                label: masterDeviceDetails.endCustomerName,
                value: masterDeviceDetails.endCustomerId,
            };
            setSelectedUser(selected_user);
            setMasterDevice({
                ...masterDeviceDetails,
                selected_user: selected_user,
            });
            props.updateForm({
                formEditDevice: {
                    formEditDevice1: {
                        friendlyName: masterDeviceDetails.friendlyName,
                        boardSerialNumber: masterDeviceDetails.boardSerialNumber,
                    },
                    formEditDevice2: {
                        selected_user: selected_user,
                        subscriptionValidity: masterDeviceDetails.subscriptionValidity
                    },
                    masterDeviceDetails,
                    errors1: {},
                    errors2: {},
                }
            })
        }

        if (!isSuperAdmin) {
            setNewUserOrganisation({
                label: currentRole.orgName,
                value: currentRole.orgId,
            });
        }

        props.clearUpdateMasterDeviceError()
        return () => {
            props.clearUpdateMasterDeviceError()
        }
    }, [masterDeviceDetails, currentRole]);

    const handleInputChange1 = (event) => {
        const { name, value } = event.target;
        setMasterDevice({ ...masterDevice, [name]: value });
        props.updateForm({
            formEditDevice: {
                ...form.formEditDevice,
                formEditDevice1: {
                    ...form.formEditDevice.formEditDevice1,
                    [name]: value
                },
                errors1: {
                    ...form && form.formEditDevice.errors1,
                    [name]: null,
                }
            }
        });
    }

    const handleInputChange2 = (event) => {
        const { name, value } = event.target;
        setMasterDevice({ ...masterDevice, [name]: value });
        props.updateForm({
            formEditDevice: {
                ...form.formEditDevice,
                formEditDevice2: {
                    ...form.formEditDevice.formEditDevice2,
                    [name]: value
                },
                errors2: {
                    ...form && form.formEditDevice.errors2,
                    [name]: null,
                }
            }
        });
    }

    const handleAddMasterDeviceUserEditChange = (value) => {
        setMasterDevice({ ...masterDevice, selected_user: value });
        props.updateForm({
            formEditDevice: {
                ...form.formEditDevice,
                formEditDevice2: {
                    ...form.formEditDevice.formEditDevice2,
                    selected_user: value
                },
                errors2: {
                    ...form && form.formEditDevice.errors2,
                    selected_user: null,
                }
            }
        });

    };

    const handleLoadUsers = (inputValue, callback) => {
        const organisationId = new_user_organisation && new_user_organisation.value;
        if (organisationId) {
            props.getUsersForAsyncSelect(organisationId, inputValue, callback);
        }
        else {
            callback([]);
        }
    };

    const subscriptionChange = (e) => {
        const { value } = e.target;
        setMasterDevice({ ...masterDevice, subscriptionValidity: value })
        props.updateForm({
            formEditDevice: {
                ...form.formEditDevice,
                formEditDevice2: {
                    ...form.formEditDevice && form.formEditDevice.formEditDevice2,
                    subscriptionValidity: value
                },
                errors2: {
                    ...form && form.formEditDevice && form.formEditDevice.errors2,
                    subscriptionValidity: null,
                }
            }
        })
    };


    //---------------------VALIDATION & PAGE NAVIGATION-----------------------------------------------------------
    const toggleTabwiz = (tab) => {
        const { formEditDevice } = form || {};
        const { formEditDevice1, formEditDevice2 } = formEditDevice || {};
        const { friendlyName, boardSerialNumber } = formEditDevice1 || {};
        const { subscriptionValidity } = formEditDevice2 || {};

        let errors = {};
        const currentErrors1 = {};
        const currentErrors2 = {};
        //---------------------TAB-1-----------------------------------------------------------
        if (activeTabwiz === 1) {
            if (!friendlyName) {
                currentErrors1.friendlyName = "Name is required"
            }
            if (!boardSerialNumber) {
                currentErrors1.boardSerialNumber = "Board no. is required"
            }

            props.updateForm({
                formEditDevice: {
                    ...formEditDevice,
                    formEditDevice1: {
                        ...form.formEditDevice.formEditDevice1,
                    },
                    errors1: currentErrors1,
                }
            })

            errors = currentErrors1;
        }
        if (activeTabwiz === 2) {
            if (!subscriptionValidity) {
                currentErrors2.subscriptionValidity = "Subscription date is required"
            }
            props.updateForm({
                formEditDevice: {
                    ...formEditDevice,
                    formEditDevice2: {
                        ...form.formEditDevice && form.formEditDevice.formEditDevice2,
                    },
                    errors2: currentErrors2,
                }
            })

            errors = currentErrors2;
        }

        if (Object.keys(errors).length === 0) {
            if (activeTabwiz !== tab) {
                var modifiedSteps = [...passedStepswiz, tab];
                if (tab >= 1 && tab <= 3) {
                    setoggleTabwiz(tab);
                    setpassedStepswiz(modifiedSteps);
                }
            }
        }
        else {
            if (activeTabwiz > tab) {
                var modifiedSteps = [...passedStepswiz, tab];
                if (tab >= 1 && tab <= 3) {
                    setoggleTabwiz(tab);
                    setpassedStepswiz(modifiedSteps);
                }
            }
        }
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        const data = {
            ...form.formEditDevice.formEditDevice1,
            ...form.formEditDevice.formEditDevice2,
            id: masterDeviceDetails.id
        }
        props.updateMasterDevice(data);
    }

    return isSuccess ? (<Navigate to={reqParams === 'master-devices-customers' ? `/devicelist/master-devices-customers/details/${masterDevice && masterDevice.id}` : `/devicelist/master-devices/details/${masterDevice && masterDevice.id}`} />) : (
        <React.Fragment>
            <div className="page-content">
                <Row>
                    <Col lg="12">
                        <Card>
                            <CardTitle className='m-2 mb-0 d-flex justify-content-between align-items-center border-bottom border-secondary'>
                                <h5 className="fw-bold">EDIT MASTER DEVICE</h5>
                                <Link className="text-dark" to={reqParams === 'master-devices-customers' ? `/devicelist/master-devices-customers/details/${masterDevice && masterDevice.id}` : `/devicelist/master-devices/details/${masterDevice && masterDevice.id}`}>
                                    <i className="mdi mdi-close fs-2"></i>
                                </Link>
                            </CardTitle>
                            <CardBody>
                                {errorMessage && (
                                    <Message
                                        type="danger"
                                        defaultMessage={errorMessage}
                                        baseClassName="alert"
                                    />
                                )}
                                <div id="progrss-wizard" className="twitter-bs-wizard">
                                    <ul className="twitter-bs-wizard-nav nav-justified nav nav-pills">
                                        <NavItem className={classnames({ active: activeTabwiz === 1 })}>
                                            <NavLink
                                                className={(classnames({ active: activeTabwiz === 1 }))}
                                                onClick={() => toggleTabwiz(1)}
                                            >
                                                <span className="step-number">01</span>
                                                <span className="step-title" style={{ paddingLeft: "10px" }}>Master Board Details</span>
                                            </NavLink>
                                        </NavItem>
                                        <NavItem className={classnames({ active: activeTabwiz === 2 })}>
                                            <NavLink
                                                className={(classnames({ active: activeTabwiz === 2 }))}
                                                onClick={() => toggleTabwiz(2)}
                                            >
                                                <span className="step-number">02</span>
                                                <span className="step-title" style={{ paddingLeft: "10px" }}>User Details</span>
                                            </NavLink>
                                        </NavItem>
                                        <NavItem className={classnames({ active: activeTabwiz === 3 })}>
                                            <NavLink
                                                className={(classnames({ active: activeTabwiz === 3 }))}
                                                onClick={() => toggleTabwiz(4)}
                                            >
                                                <span className="step-number">03</span>
                                                <span className="step-title" style={{ paddingLeft: "10px" }}>Confirm Details</span>
                                            </NavLink>
                                        </NavItem>
                                    </ul>
                                    <div id="bar" className="mt-4">
                                        <div className="mb-4">
                                            <Progress
                                                value={40 * activeTabwiz}
                                                color="success"
                                                animated
                                            />
                                        </div>
                                    </div>
                                    <TabContent activeTab={activeTabwiz} className="twitter-bs-wizard-tab-content">
                                        <TabPane tabId={1}>
                                            <Form>
                                                <Row>
                                                    <Col lg="6">
                                                        <FormGroup className="mb-3">
                                                            <Label htmlFor="basicpill-firstname-input12">
                                                                Friendly Name<span className="text-danger">*</span>
                                                            </Label>
                                                            <Input
                                                                autoFocus={true}
                                                                type="text"
                                                                name="friendlyName"
                                                                placeholder="Enter friendly name"
                                                                value={masterDevice.friendlyName}
                                                                onChange={handleInputChange1}
                                                                invalid={form && form.formEditDevice
                                                                    && form.formEditDevice.errors1 &&
                                                                    form.formEditDevice.errors1.friendlyName}
                                                            />
                                                            <FormFeedback>
                                                                {form && form.formEditDevice
                                                                    && form.formEditDevice.errors1 &&
                                                                    form.formEditDevice.errors1.friendlyName}
                                                            </FormFeedback>
                                                        </FormGroup>
                                                    </Col>
                                                    <Col lg="6">
                                                        <FormGroup className="mb-3">
                                                            <Label htmlFor="basicpill-email-input42">
                                                                Master Board Serial Number<span className="text-danger">*</span>
                                                            </Label>
                                                            <Input
                                                                type="text"
                                                                name="boardSerialNumber"
                                                                placeholder="Enter board serial number"
                                                                value={masterDevice.boardSerialNumber}
                                                                onChange={handleInputChange1}
                                                                invalid={form && form.formEditDevice
                                                                    && form.formEditDevice.errors1 &&
                                                                    form.formEditDevice.errors1.boardSerialNumber}
                                                            />
                                                            <FormFeedback>
                                                                {form && form.formEditDevice
                                                                    && form.formEditDevice.errors1 &&
                                                                    form.formEditDevice.errors1.boardSerialNumber}
                                                            </FormFeedback>
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                            </Form>
                                        </TabPane>
                                        <TabPane tabId={2}>
                                            <div>
                                                <Form>
                                                    <Row>
                                                        <Col lg="6">
                                                            <FormGroup className="mb-3">
                                                                <Label htmlFor="basicpill-pancard-input52">
                                                                    User<span className="text-danger">*</span>
                                                                </Label>
                                                                <Async
                                                                    key={new_user_organisation.value}
                                                                    styles={{
                                                                        menu: (provided) => ({
                                                                            ...provided,
                                                                            zIndex: 9999,
                                                                        }),
                                                                    }}
                                                                    id="selected_user"
                                                                    name="selected_user"
                                                                    placeholder="Select user"
                                                                    defaultOptions
                                                                    loadOptions={handleLoadUsers}
                                                                    onChange={handleAddMasterDeviceUserEditChange}
                                                                    openMenuOnFocus={true}
                                                                    menuPortalTarget={document.body}
                                                                    isDisabled={!new_user_organisation}
                                                                    defaultValue={selected_user}
                                                                />
                                                            </FormGroup>
                                                        </Col>
                                                        {/* </Row> */}
                                                        {/* <Row> */}
                                                        <Col lg="6">
                                                            <FormGroup>
                                                                <Label>
                                                                    Subscription Validity<span className="text-danger">*</span>
                                                                </Label>
                                                                <Input
                                                                    type='date'
                                                                    name='subscriptionValidity'
                                                                    onChange={subscriptionChange}
                                                                    value={masterDevice && masterDevice.subscriptionValidity && masterDevice.subscriptionValidity.split('T')[0]}
                                                                    // value={masterDevice.subscriptionValidity ? moment(masterDevice.subscriptionValidity).format('yyyy-MM-dd') : "NA"}
                                                                    invalid={form && form.formEditDevice
                                                                        && form.formEditDevice.errors2 &&
                                                                        form.formEditDevice.errors2.subscriptionValidity}
                                                                />
                                                                < FormFeedback >
                                                                    {form && form.formEditDevice
                                                                        && form.formEditDevice.errors2 &&
                                                                        form.formEditDevice.errors2.subscriptionValidity}
                                                                </FormFeedback>
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                </Form>
                                            </div>
                                        </TabPane>
                                        <TabPane tabId={3}>
                                            <div className="row justify-content-center">
                                                <Col lg="12">
                                                    {isPending ? <VWLoading /> :
                                                        <div className="text-center">
                                                            <div className="mb-4">
                                                                <i className="mdi mdi-check-circle-outline text-success display-4" />
                                                            </div>
                                                            <div>
                                                                <h5>Confirm Details</h5>
                                                                <p className="text-muted">
                                                                    The master device details are going to update. Are you sure to update?
                                                                </p>
                                                            </div>
                                                            <FormGroup>
                                                                <Button color="success" onClick={handleSubmit}>Submit</Button>
                                                                <Link className="btn btn-danger ms-4" to={reqParams === 'master-devices-customers' ? `/devicelist/master-devices-customers/details/${masterDevice && masterDevice.id}` : `/devicelist/master-devices/details/${masterDevice && masterDevice.id}`}>
                                                                    Cancel
                                                                </Link>
                                                            </FormGroup>
                                                        </div>}
                                                </Col>
                                            </div>
                                        </TabPane>
                                    </TabContent>
                                    <ul className="pager wizard twitter-bs-wizard-pager-link">
                                        <li className={activeTabwiz === 1 ? "previous disabled me-2" : "previous me-2"}>
                                            {activeTabwiz !== 1 && <Button
                                                color='primary'
                                                onClick={() => toggleTabwiz(activeTabwiz - 1)}
                                                disabled={activeTabwiz === 1}>
                                                Previous
                                            </Button>
                                            }
                                        </li>
                                        <li className={activeTabwiz === 3 ? "next disabled" : "next"}>
                                            {activeTabwiz !== 3 && <Button
                                                color='primary'
                                                onClick={() => toggleTabwiz(activeTabwiz + 1)}
                                                disabled={activeTabwiz === 3}>
                                                Next
                                            </Button>}
                                        </li>
                                    </ul>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </React.Fragment >
    );
};

const mapStateToProps = (state) => ({
    form: state.form.form,
    isPending: state.deviceDetails.isUpdateMasterDevicePending,
    errorMessage: state.deviceDetails.updateMasterDeviceErrorMessage,
    masterDeviceDetails: state.deviceDetails.masterDevice,
    isSuccess: state.deviceDetails.isMasterDeviceUpdate,
    currentProfile: state.login.currentProfile,
    // errorMessage: state.deviceDetails.errorMessage
});

const mapDispatchToProps = (dispatch) => ({
    updateMasterDevice: (device) => dispatch(updateMasterDevice(device)),
    updateForm: (updateDevices) => dispatch(updateForm(updateDevices)),
    clearUpdateMasterDeviceError: () => dispatch(clearUpdateMasterDeviceError()),
    getUsersForAsyncSelect: (organisationId, searchValue, callback) => dispatch(getUsersForAsyncSelect(organisationId, searchValue, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FormWizard);



